var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lang-menu"},[_c('a',{class:{ current: _vm.isCurrent('fr_FR') },on:{"click":function($event){_vm.setLang('fr_FR')}}},[_c('img',{attrs:{"src":require("../../assets/flag-fr.svg"),"alt":"Français"}})]),_vm._v(" "),_c('a',{class:{ current: _vm.isCurrent('en_GB') },on:{"click":function($event){_vm.setLang('en_GB')}}},[_c('img',{attrs:{"src":require("../../assets/flag-en.svg"),"alt":"Français"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78718440","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangMenu/LangMenu.vue
// module id = 640
// module chunks = 1